import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import {messages} from './i18n.js';
import VueMeta from 'vue-meta'

Vue.use(VueI18n);

Vue.use(VueMeta, {
  	keyName: 'metaInfo',
  	attribute: 'data-vmid'
});

const i18n = new VueI18n({
	locale: "hu",
	messages
});

new Vue({
	el: '#app',
	i18n,
	render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js